import * as React from 'react';
import { forceCheck } from 'react-lazyload';

import { CategoryHeader } from './components/CategoryHeader';
import { CategoryPulldown } from './components/CategoryPulldown';
import { CategorySidebar } from './components/CategorySidebar';
import { CategorySidebarWrapper } from './styles/CategoryPage';

import { MetaTags } from './components/Meta';

import { TemplateData, CategoryData } from './App';
import { TemplateCard } from './components/TemplateCard';

import { WebsiteLogger } from '@prezi/client-logger-module';
import { CATEGORY_ALL_SLUG, getCanoncialUrl } from './components/TemplateUtils';
declare const Site: any;

interface CategoryPageProps {
    currentCategory: CategoryData;
    templates: Array<TemplateData>;
    categories: Array<CategoryData>;
    basePath: string;
    categoryString: string;
}

export default class CategoryPage extends React.Component<CategoryPageProps, any> {
    constructor(props: CategoryPageProps) {
        super(props);
    }

    meta_tags() {
        return <MetaTags
                    title={ this.props.currentCategory.page_title }
                    description={ this.props.currentCategory.meta_description }
                    slug={ this.props.currentCategory.slug }
                    canonicalUrl={ getCanoncialUrl(this.props.currentCategory.slug) }
                />;
    }

    body() {
        return (
            <div>
                <div className={ 'col-lg-2 visible-lg' }>
                    <CategorySidebar
                        categories={ this.props.categories }
                        basePath={ this.props.basePath }
                        currentCategory={ this.props.currentCategory }
                        categoryString={ this.props.categoryString }
                    />
                </div>
                <div className={ 'container visible-md visible-sm visible-xs' }>
                    <CategoryPulldown
                        categories={ this.props.categories }
                        basePath={ this.props.basePath }
                        currentCategory={ this.props.currentCategory }
                    />
                </div>
                <div className={ 'col-xs-12 col-lg-10 pad-zero' }>
                    { this.props.templates.map(template => (
                        <TemplateCard key={ template.slug } template={ template } basePath={ this.props.basePath } />
                    )) }
                </div>
            </div>
        );
    }

    getCategoryClickTrackingText = (slug: string) => {
        if (slug !== CATEGORY_ALL_SLUG) {
            return `${slug}`;
        } else {
            return 'all';
        }
    }

    logCategoryView = function() {
        const categoryTrackingText = this.getCategoryClickTrackingText(this.props.currentCategory.slug);

        WebsiteLogger.log({
            action: 'view',
            object: 'logged_element',
            trigger: 'view',
            payload: {element_text: categoryTrackingText, element_type: 'category_page', source_url: window.location.pathname, user_id: Site.user_id},
        });
    };

    componentDidMount() {
        this.logCategoryView();
    }

    componentDidUpdate() {
        forceCheck();
        this.logCategoryView();
    }

    render() {
        return (
            <div>
                { this.meta_tags() }

                <CategoryHeader category={ this.props.currentCategory } />

                <CategorySidebarWrapper className={ 'section' }>
                    <div className={ 'container' }>
                        <div className={ 'row' }>

                            { this.body() }

                        </div>
                    </div>
                </CategorySidebarWrapper>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/CategoryPage.tsx